import React from 'react';

const Footer = () => {
    return (
        <footer>
            <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
            <span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400 p-2 text-center">© 3 <a href="https://devkbin.netlify.app/" class="hover:underline">DevKbin</a>. All Rights Reserved.
            </span>
        </footer>
    );
};

export default Footer;